import {useTranslation} from 'react-i18next'
import {Checkbox, Link} from '@components/lib'
import {useDispatch, useSelector} from 'react-redux'

import routes from 'routes'
import {assetsConfig} from 'config/wallet/assetsConfig'
import {toggleShowBalances} from 'redux/slices/walletConfig'

import {
  Wrapper,
  Header,
  Title,
  AssetTable,
  AssetTableHeader,
  AssetTableTh,
  AssetTableBody,
  AssetTableWrapper,
  HeaderTop,
} from './WalletAssets.styles'
import AssetRow from './AssetRow'

const WalletAssets = ({...rest}) => {
  const {t} = useTranslation()
  const {hideSmallBalances} = useSelector(state => state.walletConfig)
  const dispatch = useDispatch()
  return (
    <Wrapper {...rest}>
      <Header>
        <HeaderTop>
          <Title>{t('wallet.assets.title')}</Title>
          <Checkbox
            name='hide_small'
            label={t('wallet.assets.hideSmallBalances')}
            value={hideSmallBalances}
            onChange={({value}) => dispatch(toggleShowBalances(value))}
          />
        </HeaderTop>
        <Link
          to={routes.wallet.legacyWallets.path}
          text='Go to old Assets'
          style={{fontSize: '15px', textAlign: 'end'}}
        />
      </Header>
      <AssetTableWrapper>
        <AssetTable>
          <AssetTableHeader>
            <tr>
              <AssetTableTh>{t('wallet.assets.table.currency')}</AssetTableTh>
              <AssetTableTh>{t('wallet.assets.table.available')}</AssetTableTh>
              <AssetTableTh>{t('wallet.assets.table.total')}</AssetTableTh>
              <AssetTableTh>{t('wallet.assets.table.actions')}</AssetTableTh>
            </tr>
          </AssetTableHeader>
          <AssetTableBody>
            {assetsConfig.map(({id}) => (
              <AssetRow key={id} apiId={id} hideSmallBalance={hideSmallBalances} />
            ))}
          </AssetTableBody>
        </AssetTable>
      </AssetTableWrapper>
    </Wrapper>
  )
}

WalletAssets.propTypes = {}
WalletAssets.defaultProps = {}

export default WalletAssets
